module.exports = __webpack_public_path__ + "static/img/logo.d41ea6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = zxL1
// module chunks = 24